"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const defaultOptions = {
    useUndefinedParams: false
};
const castProps = (mappings, _options
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) => {
    const options = Object.assign({}, defaultOptions, _options);
    return (route) => {
        const result = {};
        for (const key in mappings) {
            const mapping = mappings[key];
            if (typeof mapping === "function") {
                const val = route.params[key];
                result[key] = mapping(val);
            }
            else {
                const val = (mapping.routeKey) ? (0, get_1.default)(route, mapping.routeKey) : route.params[key];
                result[key] = mapping.type(val);
            }
        }
        if (options.useUndefinedParams) {
            for (const key in route.params) {
                if (!Object.prototype.hasOwnProperty.call(result, key)) {
                    result[key] = route.params[key];
                }
            }
        }
        return result;
    };
};
exports.default = castProps;
